import { ErrorStorage } from './ErrorStorage';
import { MutableConsentName } from '../appTypings';
import { CONSENT_PATH } from '../Routes/routeNames';
import { yleConsentSdkHeadless } from '@yleisradio/consent-sdk/headless';
import { Language } from '@yleisradio/areena-types';
import { ApplicationResolution } from '../applicationResolution';
import { setUILanguage } from '../localizations/language';

export const shouldRedirectToConsentView = (pathname: string) => {
  if (process.env.NO_COOKIES_STORAGE === 'true') {
    return false;
  }
  if (ErrorStorage.hasError()) {
    return false;
  }
  if (pathname === CONSENT_PATH) {
    return false;
  }

  return true;
};

export const isMutableConsentName = (
  consentName: any
): consentName is MutableConsentName =>
  consentName === 'development' ||
  consentName === 'targeting' ||
  consentName === 'embedded_social_media';

export const hasDevelopmentConsent = () => {
  const consentObject = yleConsentSdkHeadless.getConsent();
  if (consentObject) {
    return Boolean(consentObject['development']);
  }
  return false;
};

export const handleLanguageSelect =
  (
    closeDropdown: () => void,
    applicationResolution: ApplicationResolution,
    currentLanguage: Language,
    e2eTests: boolean
  ) =>
  (language: Language) => {
    setUILanguage(language);
    closeDropdown();
    if (currentLanguage !== language) {
      window.location.assign(
        `/${CONSENT_PATH}?resolution=${applicationResolution}${e2eTests ? '&e2e_tests=true' : ''}`
      );
    }
  };
